'use strict';

var FlightClassMixGraphFilterFactory = function FlightClassMixGraphFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['FlightLegCabinDtdFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function FlightClassMixGraphFilter() {
    this.sourceType = 'class';
    this.supportedSourceTypes = ['flight-class-profile-mode', 'class', 'class-post-departure'];
    this.targetType = 'flight-class-mix-graph';
    this.filterStrategies = [];
    this.registerFilters(injectedFilters);
  }
  FlightClassMixGraphFilter.prototype = Object.create(DemandFilter.prototype);
  FlightClassMixGraphFilter.prototype.canFilter = function (sourceType, targetType) {
    return this.supportedSourceTypes.indexOf(sourceType) > -1 && this.targetType === targetType;
  };
  return FlightClassMixGraphFilter;
};
FlightClassMixGraphFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = FlightClassMixGraphFilterFactory;